export default __webpack_public_path__ + "SolutionFormationImages5.10054e0.png";